import { render, staticRenderFns } from "./MyPaySlips.vue?vue&type=template&id=778870d3"
import script from "./MyPaySlips.vue?vue&type=script&lang=js"
export * from "./MyPaySlips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports